import styles from './AutoComplete.module.scss';
import { IAutoCompleteItem } from '../interfaces/IAutoCompleteItem';
import { IAutoCompleteProps } from '../interfaces/IAutoCompleteProps';

function AutoComplete<T extends IAutoCompleteItem>({
  type,
  children,
  options,
  noFoundMessage,
  isActive,
  isError,
  handleAutoCompleteSelect,
}: IAutoCompleteProps<T>) {
  return (
    <div className={styles.Container} data-type={type}>
      {children}
      {options && (typeof isActive === 'boolean' ? isActive : true) && !isError && (
        <ul className={styles.OptionsList} tabIndex={0} id="autoCompleteList">
          {options.length ? (
            options.map((item: T, index: number) => (
              <li
                key={index}
                className={styles.OptionItem}
                onMouseDown={e => {
                  // preventDefault: иначе blur инпута срабатывает раньше click и выбор «теряется»
                  e.preventDefault();
                  handleAutoCompleteSelect?.(item.value)();
                }}
              >
                {item.label}
              </li>
            ))
          ) : (
            <li className={styles.Item}>{noFoundMessage}</li>
          )}
        </ul>
      )}
    </div>
  );
}

export { AutoComplete };
